module.exports = __webpack_public_path__ + "img/category-brand-hover.92e746ac.png";